import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home"

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About')
  }, 
  {
    path: '/salon',
    name: 'Salon',
    component: () => import('@/views/Salon')
  }, 
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products')
  }, 
  {
    path: '/productPage/:productId',
    name: 'ProductPage',
    component: () => import('@/views/ProductPage'), 
    props: true
  }, 
  {
    path: '/shoppingCart',
    name: 'ShoppingCart',
    component: () => import('@/views/ShoppingCart'), 
  }, 
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('@/views/Checkout'), 
  }, 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL, 
  routes, 
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

export default router
